import { useContext, useEffect, useState } from "react"
import { dating_goals, diet, drinking, family_perferences, gender, intimacy_preferences, logo_img, pets, political_views, pronouns, relationship_status, relationship_style, religion, sexual_identity, smoking, star_sign } from "../../../util/util"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { create } from "../../../controllers/accounts/mastodon_accounts"
import { CardLayout1 } from "../register/card_layout_1"
import { CardLayout2 } from "../register/card_layout_2"
import { PhotoGrid } from "../register/photo_grid"
import { UserContext } from "../../../context/UserContext"
import { Box, Button, Typography } from "@mui/material"
import { useProfileComplete } from "../../../hooks/useProfileComplete"

export const ProfileQuesitons = ({page, setPage, register_page, token, userDetails, profile, refresh, setRefresh}) => {

    profile = profile ?? []
        
    //values
    const [pronoun_value, set_pronoun_value] = useState(profile?.pronouns ?? [])
    const [gender_value, set_gender_value] = useState(profile?.gender_identity ?? [])
    const [sexual_identity_value, set_sexual_identity_value] = useState(profile?.sexual_identity ?? [])
    const [relationship_style_value, set_relationship_style_value] = useState(profile?.relationship_style ?? [])
    const [dating_goals_value, set_dating_goals_value] = useState(profile?.dating_goals ?? [])
    const [relationship_status_value, set_relationship_status_value] = useState(profile?.relationship_status ?? [])
    const [drinking_value, set_drinking_value] = useState(profile?.drinking ?? [])
    const [smoking_cig_value, set_smoking_cig_value] = useState(profile?.smoking ?? [])
    const [smoking_weed_value, set_smoking_weed_value] = useState(profile?.weed ?? [])
    const [political_views_value, set_political_views_value] = useState(profile?.political_Boxs ?? [])
    const [religion_value, set_religion_value] = useState(profile?.religion ?? [])
    const [diet_value, set_diet_value] = useState(profile?.diet ?? [])
    const [star_sign_value, set_star_sign_value] = useState(profile?.star_sign ?? [])
    const [pets_value, set_pets_value] = useState(profile?.pets ?? [])
    const [family_perferences_value, set_family_perferences_value] = useState(profile?.family_preference ?? [])
    const [intimacy_preferences_value, set_intimacy_preferences_value] = useState(profile?.intimacy_preferences ?? [])

    //toggle values
    const [pronoun_open, set_pronoun_open] = useState(false)
    const [gender_open, set_gender_open] = useState(false)
    const [sexual_identity_open, set_sexual_identity_open] = useState(false)
    const [relationship_style_open, set_relationship_style_open] = useState(false)
    const [dating_goals_open, set_dating_goals_open] = useState(false)
    const [relationship_status_open, set_relationship_status_open] = useState(false)
    const [drinking_open, set_drinking_open] = useState(false)
    const [smoking_cig_open, set_smoking_cig_open] = useState(false)
    const [smoking_weed_open, set_smoking_weed_open] = useState(false)
    const [political_views_open, set_political_views_open] = useState(false)
    const [religion_open, set_religion_open] = useState(false)
    const [diet_open, set_diet_open] = useState(false)
    const [star_sign_open, set_star_sign_open] = useState(false)
    const [pets_open, set_pets_open] = useState(false)
    const [family_perferences_open, set_family_perferences_open] = useState(false)
    const [intimacy_preferences_open, set_intimacy_preferences_open] = useState(false)
    const [avatar, set_avatar] = useState(userDetails?.avatar ?? logo_img)
    const [photo_list_value, set_photo_list_value] = useState(profile?.photos ?? [])
    const validPhotoCount = photo_list_value.filter((item) => item?.img).length
    const totalImageCount = (avatar ? 1 : 0) + validPhotoCount
    
    const { setUserDetails } = useContext(UserContext)
    const { recheckProfile } = useProfileComplete(userDetails)

    const queryClient = useQueryClient()
    const mutationMongoDB = useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            console.log('Registration API response:', data);
            if(data?.error){
                alert(data?.error || 'Registration Errors');
            }
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ['getSingleAccount', userDetails?.id] })
            localStorage.setItem('user', JSON.stringify({...userDetails, user:profile}))
            setUserDetails({...userDetails, user:{
                pronouns:pronoun_value,
                gender_identity:gender_value,
                sexual_identity:sexual_identity_value,
                relationship_style:relationship_style_value,
                dating_goals:dating_goals_value,
                relationship_status:relationship_status_value,
                drinking:drinking_value,
                smoking:smoking_cig_value,
                weed:smoking_weed_value,
                political_views:political_views_value,
                religion:religion_value,
                diet:diet_value,
                star_sign:star_sign_value,
                pets:pets_value,
                family_preference:family_perferences_value,
                intimacy_preferences:intimacy_preferences_value,
                photos: photo_list_value,
            }})
            if(profile?.length > 0){
                setRefresh(!refresh)
            }
            // Trigger profile completion check after save
            if(recheckProfile) {
                console.log('Triggering profile completion check after save');
                setTimeout(() => recheckProfile(), 500);
            }
        },
        onError: (error) => {
            console.error('Registration API error:', error);
            alert('Registration failed. See console for details.');
        },
    })

    const sendMongoDBRegistration = (photo_list) => {
        if (typeof setRefresh === 'function') {
            setRefresh(!refresh)
        }
        mutationMongoDB.mutate({
            token,
            mastodon_id:userDetails?.id,
            reg_fields: {
                pronouns:pronoun_value,
                gender_identity:gender_value,
                sexual_identity:sexual_identity_value,
                relationship_style:relationship_style_value,
                dating_goals:dating_goals_value,
                relationship_status:relationship_status_value,
                drinking:drinking_value,
                smoking:smoking_cig_value,
                weed:smoking_weed_value,
                political_views:political_views_value,
                religion:religion_value,
                diet:diet_value,
                star_sign:star_sign_value,
                pets:pets_value,
                family_preference:family_perferences_value,
                intimacy_preferences:intimacy_preferences_value,
                photos:photo_list ?? photo_list_value,
            }
        })
    }
    
    let card1_fields = [
        {
            value:pronoun_value,
            setValue:set_pronoun_value,
            limit:1,
            page:page,
            setPage:setPage,
            open:register_page ? true : pronoun_open,
            setOpen:register_page ? () =>{} : set_pronoun_open, 
            btn_label:'Pronouns', 
            default_btn_label:pronouns[pronoun_value[0]] ?? pronouns[0],
            option_values:pronouns,
            subtitle:'What pronouns best fit you?',
            popup_label:'What does this mean?',
            popup_content:<Typography>Pronouns are words used to refer to people, and they are an important part of gender identity. LGBTQ+ people may use a variety of pronouns, including he/him, she/her, they/them, and nonbinary pronouns. </Typography>,
            page_number:4,
            required:true
        },
        {
            value:gender_value,
            setValue:set_gender_value,
            limit:1,
            page:page,
            setPage:setPage,
            open:register_page ? true: gender_open,
            setOpen:register_page ? () =>{} : set_gender_open, 
            btn_label:'Gender Identity', 
            default_btn_label:gender[gender_value[0]] ?? gender[0],
            option_values:gender,
            subtitle:"What's your gender identity?",
            popup_label:'What does this mean?',
            popup_content:<Typography>Gender identity is a person's internal sense of their gender, which can be male, female, both, or something else. It can be the same as or different from the sex they were assigned at birth.</Typography>,
            page_number:5,
            required:true
        },
        {
            value:sexual_identity_value,
            setValue:set_sexual_identity_value,
            limit:1,
            page:page,
            setPage:setPage,
            open:register_page ? true : sexual_identity_open,
            setOpen:register_page ? () =>{} : set_sexual_identity_open, 
            btn_label:'Sexual Identity', 
            default_btn_label: sexual_identity[sexual_identity_value[0]] ?? sexual_identity[0],
            option_values:sexual_identity,
            subtitle:"What's your sexual identity?",
            popup_label:'What does this mean?',
            popup_content:<Typography>Your sexual identity, or sexual orientation, is a term used to describe the sex of a person, or people, you are attracted to in a sexual or romantic way. Most people become aware of their sexual orientation when they reach puberty, but it is possible for these feelings to change over time, or never appear at all.</Typography>,
            page_number:6,
            required:true
        },
        {
            value:relationship_style_value,
            setValue:set_relationship_style_value,
            limit:1,
            page:page,
            setPage:setPage,
            open:register_page ? true : relationship_style_open,
            setOpen:register_page ? () =>{} : set_relationship_style_open, 
            btn_label:'Relationship Style', 
            default_btn_label:relationship_style[relationship_style_value[0]] ?? relationship_style[0],
            option_values:relationship_style,
            subtitle:'What is your relationship style?',
            page_number:7,
            required:true
        },
        {
            value:dating_goals_value,
            setValue:set_dating_goals_value,
            limit:1,
            page:page,
            setPage:setPage,
            open:register_page ? true : dating_goals_open,
            setOpen:register_page ? () =>{} : set_dating_goals_open, 
            btn_label:'Social Goal', 
            default_btn_label:dating_goals[dating_goals_value[0]] ?? dating_goals[0],
            option_values:dating_goals,
            subtitle:'What are you primarily looking for?',
            page_number:8,
            required:true
        },
    ]

    let card2_fields = [
        {
            value:relationship_status_value,
            setValue:set_relationship_status_value,
            limit:1,
            page:page,
            setPage:setPage,
            open:register_page ? true : relationship_status_open,
            setOpen:register_page ? () =>{} : set_relationship_status_open,
            btn_label:'Relationship Status',
            default_btn_label:relationship_status_value[0] ?? relationship_status[0],
            option_values:relationship_status,
            subtitle:'What is your relationship status?',
            icon:'❤️',
            page_number:9,
            required:true
        },
        {
            value:drinking_value,
            setValue:set_drinking_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : drinking_open,
            setOpen:register_page ? () =>{} : set_drinking_open,
            btn_label:'Drinking',
            default_btn_label:drinking_value[0] ?? drinking[0],
            option_values:drinking,
            subtitle:'Do you drink?',
            icon:'🍷',
            page_number:10
        },
        {
            value:smoking_cig_value,
            setValue:set_smoking_cig_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : smoking_cig_open,
            setOpen:register_page ? () =>{} : set_smoking_cig_open,
            btn_label:'Cigaretts',
            default_btn_label:smoking_cig_value[0] ?? smoking[0],
            option_values:smoking,
            subtitle:'Do you smoke cigarettes?',
            icon:'🚬',
            page_number:11
        },
        {
            value:smoking_weed_value,
            setValue:set_smoking_weed_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : smoking_weed_open,
            setOpen:register_page ? () =>{} : set_smoking_weed_open,
            btn_label:'Marijuana',
            default_btn_label:smoking_weed_value[0] ?? smoking[0],
            option_values:smoking,
            subtitle:'Do you use cannabis?',
            icon:'🌿',
            page_number:12
        },
        {
            value:political_views_value,
            setValue:set_political_views_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : political_views_open,
            setOpen:register_page ? () =>{} : set_political_views_open,
            btn_label:'Political Boxs',
            default_btn_label:political_views_value[0] ?? political_views[0],
            option_values:political_views,
            subtitle:'What are your political views?',
            icon:'⚖️',
            page_number:13
        },
        {
            value:religion_value,
            setValue:set_religion_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : religion_open,
            setOpen:register_page ? () =>{} : set_religion_open,
            btn_label:'Religion',
            default_btn_label:religion_value[0] ?? religion[0],
            option_values:religion,
            subtitle:"What's your religion?",
            icon:'🙏',
            page_number:14
        },
        {
            value:diet_value,
            setValue:set_diet_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : diet_open,
            setOpen:register_page ? () =>{} : set_diet_open,
            btn_label:'Diet',
            default_btn_label:diet_value[0] ?? diet[0],
            option_values:diet,
            subtitle:"What's your diet like?",
            icon:'🍽️',
            page_number:15
        },
        {
            value:star_sign_value,
            setValue:set_star_sign_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : star_sign_open,
            setOpen:register_page ? () =>{} : set_star_sign_open,
            btn_label:'Star sign',
            default_btn_label:star_sign_value[0] ?? star_sign[0],
            option_values:star_sign,
            subtitle:"What's your sign?",
            icon:'💫',
            page_number:16
        },
        {
            value:pets_value,
            setValue:set_pets_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : pets_open,
            setOpen:register_page ? () =>{} : set_pets_open,
            btn_label:'Pets',
            default_btn_label:pets_value[0] ?? pets[0],
            option_values:pets,
            subtitle:'Do you have any pets?',
            icon:'🐾',
            page_number:17
        },
        {
            value:family_perferences_value,
            setValue:set_family_perferences_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : family_perferences_open,
            setOpen:register_page ? () =>{} : set_family_perferences_open,
            btn_label:'Family Perferences',
            default_btn_label:family_perferences_value[0] ?? family_perferences[0],
            option_values:family_perferences,
            subtitle:'Do you have or want kids?',
            icon:'🍼',
            page_number:18
        },
        {
            value:intimacy_preferences_value,
            setValue:set_intimacy_preferences_value,
            page:page,
            setPage:setPage,
            open:register_page ? true : intimacy_preferences_open,
            setOpen:register_page ? () =>{} : set_intimacy_preferences_open,
            btn_label:'Intimacy Perferences',
            default_btn_label:intimacy_preferences_value[0] ?? intimacy_preferences[0],
            option_values:intimacy_preferences,
            subtitle:'Choose your intimacy perferences',
            icon:'💗',
            page_number:19
        },
    ]

    useEffect(() => {
        profile?.pronouns && set_pronoun_value(profile?.pronouns)
        set_gender_value(profile?.gender_identity ?? [])
        set_sexual_identity_value(profile?.sexual_identity ?? [])
        set_relationship_style_value(profile?.relationship_style ?? [])
        set_dating_goals_value(profile?.dating_goals ?? [])
        set_relationship_status_value(profile?.relationship_status ?? [])
        set_drinking_value(profile?.drinking ?? [])
        set_smoking_cig_value(profile?.smoking ?? [])
        set_smoking_weed_value(profile?.weed ?? [])
        set_political_views_value(profile?.political_views ?? [])
        set_religion_value(profile?.religion ?? [])
        set_diet_value(profile?.diet ?? [])
        set_star_sign_value(profile?.star_sign ?? [])
        set_pets_value(profile?.pets ?? [])
        set_family_perferences_value(profile?.family_preference ?? [])
        set_intimacy_preferences_value(profile?.intimacy_preferences ?? [])
        set_photo_list_value(profile?.photos ?? [])
    }, [])
    
    return(
    <>
        {page === 3 &&
            <>
                <PhotoGrid sendMongoDBRegistration={sendMongoDBRegistration} avatar={avatar} set_avatar={set_avatar} token={token} photo_list_value={photo_list_value}  set_photo_list_value={set_photo_list_value} />
                <Box style={{marginTop:100, padding:20}}>
                    {totalImageCount < 3 && (
                        <Typography color="error" variant="body2" sx={{ mb: 1 }}>
                            You must add at least 3 images total (including your avatar).
                        </Typography>
                    )}
                    <Button variant="contained" disabled={totalImageCount < 3} onClick={() => setPage(page+1)}>
                        NEXT
                    </Button>
                    <Button variant="text" onClick={() => page > 0 ? setPage(page-1) : console.log('this is page 1')}>
                        BACK
                    </Button>
                </Box>
            </>
        }

        {!register_page &&
        <>
            <PhotoGrid sendMongoDBRegistration={sendMongoDBRegistration} avatar={avatar} set_avatar={set_avatar} token={token} photo_list_value={photo_list_value}  set_photo_list_value={set_photo_list_value} />
            <Box style={{height:50}}></Box>
        </>
        }

        {card1_fields.map((item, i) => 
        page === item.page_number &&
            <CardLayout1
                key={i}
                value={item.value}
                setValue={item.setValue}
                register_page={register_page}
                limit={item.limit}
                page={item.page}
                setPage={item.setPage}
                open={item.open} 
                setOpen={item.setOpen} 
                btn_label={item.btn_label} 
                default_btn_label={item.default_btn_label} 
                option_values={item.option_values} 
                subtitle={item.subtitle}
                popup_label={item.popup_label}
                popup_content={item.popup_content}
                sendMongoDBRegistration={sendMongoDBRegistration}
            />
        )}

        {!register_page &&
        card1_fields.map((item, i) => 
            <CardLayout1
                key={i}
                value={item.value}
                setValue={item.setValue}
                register_page={register_page}
                limit={item.limit}
                page={item.page}
                setPage={item.setPage}
                open={item.open} 
                setOpen={item.setOpen} 
                btn_label={item.btn_label} 
                default_btn_label={item.default_btn_label} 
                option_values={item.option_values} 
                subtitle={item.subtitle}
                popup_label={item.popup_label}
                popup_content={item.popup_content}
                sendMongoDBRegistration={sendMongoDBRegistration}
                required={item.required}
            />
        )}

        {card2_fields.map((item, i) =>
        page === item.page_number &&
            <CardLayout2
                key={i}
                value={item.value}
                setValue={item.setValue}
                register_page={register_page}
                limit={item.limit}
                page={item.page}
                setPage={item.setPage}
                open={item.open} 
                setOpen={item.setOpen} 
                btn_label={item.btn_label} 
                default_btn_label={item.default_btn_label} 
                option_values={item.option_values} 
                subtitle={item.subtitle}
                icon={item.icon}
                sendMongoDBRegistration={sendMongoDBRegistration}
            />
        )}

        {!register_page &&
        card2_fields.map((item, i) =>
            <CardLayout2
                key={i}
                value={item.value}
                setValue={item.setValue}
                register_page={register_page}
                limit={item.limit}
                page={item.page}
                setPage={item.setPage}
                open={item.open} 
                setOpen={item.setOpen} 
                btn_label={item.btn_label} 
                default_btn_label={item.default_btn_label} 
                option_values={item.option_values} 
                subtitle={item.subtitle}
                icon={item.icon}
                sendMongoDBRegistration={sendMongoDBRegistration}
                required={item.required}
            />
        )}
    </>
    )
}